import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetCoursesForCandidateResponse extends BackendResponse {
  items: Course[];
}

export const getCoursesForCandidate =
  withNextApi<GetCoursesForCandidateResponse>("/cvp/CvpGetCoursesForCandidate");

export interface Course {
  id: number;
  idCandidate: number;
  fromDate: string | null;
  toDate: string | null;
  references: string;
  courseType: string;
  courseTypeId: number;
  expirationDate: string | null;
  comment: string;
  arranger: string;
}
